import InvalidElement from '../../../../domain/Folder/InvalidElementInterface';
import { ViewBlockInterface } from '../../../../domain/ViewDossier/ViewBlock'
import PresentationElement from './PresentationElement';

interface Props {
  block: ViewBlockInterface
  state: string | null
  pageId: string
  invalidElements: InvalidElement[]
  onInvalidateToggle: (
    isInvalid: boolean,
    elementId: string,
    comment: string,
    blockId: string,
    receiptId: string | null,
    value: string | null,
    pageId: string,
  ) => void
  onCommentChange: (elementId: string, receiptId: string|null, comment: string) => void
}

const PresentationBlock = ({ block, state, pageId, invalidElements, onInvalidateToggle, onCommentChange }: Props): JSX.Element => {
  return (
    <div className="card card--validated card--validated--summary u-mbl">
      <div className="card__first">
        <h3 className="card__title">{block.name}</h3>
        <div className="flex-container">
          <div className="col-md-12">
            {block.elements.map((element) => {
              return (
                <PresentationElement
                  key={element.id}
                  element={element}
                  blockId={block.id}
                  state={state}
                  pageId={pageId}
                  onInvalidateToggle={onInvalidateToggle}
                  onCommentChange={onCommentChange}
                  invalidElement={invalidElements.find(invalidElement => invalidElement.elementId === element.id) ?? null}
                />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PresentationBlock
